import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { listAdminBlocksApi, deleteAdminBlockApi } from "api/admin";
import {
  C,
  Panel,
  SkeletonRows,
  Empty,
  SearchBar,
  Pagination,
  formatDate,
  dangerBtnSm,
} from "./admin_ui";

export default function AdminBlocks() {
  const [params, setParams] = useSearchParams();
  const search = params.get("q") || "";
  const page = parseInt(params.get("page") || "1", 10) || 1;
  const [searchInput, setSearchInput] = useState(search);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tick, setTick] = useState(0);

  useEffect(() => setSearchInput(search), [search]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      const r = await listAdminBlocksApi({
        search: search || undefined,
        page,
        limit: 20,
      });
      if (cancelled) return;
      if (r?.success) setData({ items: r.items || [], total: r.total || 0 });
      else setError(r?.error || "조회 실패");
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [search, page, tick]);

  const setParam = (key, value) => {
    const next = new URLSearchParams(params);
    if (value === undefined || value === null || value === "") next.delete(key);
    else next.set(key, value);
    if (key !== "page") next.set("page", "1");
    setParams(next, { replace: false });
  };

  const handleUnblock = async (docId) => {
    if (!window.confirm("이 차단을 강제 해제하시겠습니까?")) return;
    const r = await deleteAdminBlockApi(docId);
    if (r?.success) setTick((t) => t + 1);
    else alert(r?.error || "해제 실패");
  };

  return (
    <>
      <div>
        <div
          style={{
            fontSize: 24,
            fontWeight: 800,
            color: C.ink,
            letterSpacing: "-0.02em",
          }}
        >
          차단 관리
        </div>
        <div style={{ marginTop: 4, fontSize: 13, color: C.sub }}>
          전체 {data.total.toLocaleString()}건 — 운영자가 차단을 강제 해제할 수 있습니다.
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1 }} />
        <SearchBar
          value={searchInput}
          onChange={setSearchInput}
          onSubmit={() => setParam("q", searchInput.trim())}
          placeholder="차단한 사람 / 차단당한 사람 ID"
        />
      </div>

      <Panel title="차단 목록" count={data.total}>
        {loading ? (
          <SkeletonRows count={6} />
        ) : error ? (
          <Empty label={error} />
        ) : data.items.length === 0 ? (
          <Empty />
        ) : (
          data.items.map((b) => (
            <div
              key={b.docId}
              style={{
                display: "flex",
                gap: 10,
                padding: "12px 0",
                borderBottom: `1px solid ${C.line}`,
                fontSize: 13,
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: C.ink, fontWeight: 600 }}>
                  {b.blockerId} → {b.name || b.id}
                </div>
                <div
                  style={{ marginTop: 4, fontSize: 11, color: C.sub }}
                >
                  차단됨 ID: {b.id} · {formatDate(b.createDate)}
                </div>
              </div>
              <button
                type="button"
                onClick={() => handleUnblock(b.docId)}
                style={{ ...dangerBtnSm, height: 30, fontSize: 11 }}
              >
                해제
              </button>
            </div>
          ))
        )}
        <Pagination
          page={page}
          limit={20}
          total={data.total}
          onChange={(p) => setParam("page", String(p))}
        />
      </Panel>
    </>
  );
}
